<template>
  <div class="pub-redirect">
    <div v-if="error" class="pub-redirect-error">
      <p>Publication not found.</p>
      <button @click="$router.push('/home')">Go to feed</button>
    </div>
    <div v-else class="pub-redirect-loading">
      <div class="spinner" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PubRedirect',

  async mounted () {
    const id = this.$route.params.id
    try {
      // Fetch the publication data
      const res = await this.$axios.post('publication.php',{type:"getPublicationByIds",pubs:[id]})
      if (res.data.length === 0) throw new Error('Not found')
      const pub = res.data[0]
      // pub.likes = []
        // pub.views = []
      // Store the id so Publications.vue knows to jump to it after loading the feed
      this.$store.commit('player/setFeaturedPub', pub)

      // Redirect to home — Home.vue is already mounted (v-show), Publications will handle the rest
      this.$router.replace('/')
    } catch (e) {
      console.error(e)
      this.error = true
    }
  },

  data () {
    return { error: false }
  },
}
</script>

<style scoped>
.pub-redirect {
  position: fixed;
  inset: 0;
  background: #0a0e26;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 212, 255, 0.2);
  border-top-color: #00d4ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.pub-redirect-error {
  text-align: center;
  color: #e0f7ff;
}
.pub-redirect-error button {
  margin-top: 16px;
  padding: 10px 24px;
  background: rgba(0, 212, 255, 0.15);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  color: #00d4ff;
  cursor: pointer;
  font-size: 14px;
}
</style>